import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './MessageModal.scss'

const SIGNED_REALTOR_NOT_SIGNED_BROKER = 'signed_realtor_not_signed_broker';

export default class MessageModal extends Component {

    static get propTypes() {
        return {
            realtorId: PropTypes.number,
            message: PropTypes.string,
            messageType: PropTypes.string,
            managingBrokerEmail: PropTypes.string,
            userType: PropTypes.string,
            immediateProposal: PropTypes.string,
            showResendReferralLink: PropTypes.string,
            onClose: PropTypes.function
        };
    }

    state = {
        realtorId: this.props.realtorId,
        message: this.props.message,
        messageType: this.props.messageType,
        managingBrokerEmail: this.props.managingBrokerEmail,
        userType: this.props.userType,
        immediateProposal: this.props.immediateProposal,
        showResendReferralLink: this.props.showResendReferralLink,
        onClose: this.props.onClose
    };

    handleResendReferralAgreement = () => {
        $.post('resendReferral-json', {
            realtorId: this.props.realtorId
        }).then(data => {
            if (checkAjax(data)) {
                this.props.onClose();
            }
        }).fail(() => {
            defaultAjaxError();
        });
    };

    render() {
        const {message, messageType, managingBrokerEmail, userType, immediateProposal, showResendReferralLink } = this.state;
        const showSignedRealtorNotSignedBrokerContent = SIGNED_REALTOR_NOT_SIGNED_BROKER === messageType;
        const showResendLink = showResendReferralLink === 'true';
        const defaultMessageSignedRealtorNotSignedBroker = `We are waiting for your managing broker
            ${managingBrokerEmail} to sign our referral agreement. Meanwhile, save time by completing the necessary
            information for your first proposal. Reach out via chat if you need guidance.`;
        const messageWithResendLink = `We are waiting for you managing broker ${managingBrokerEmail} to sign our
        referral agreement. Click on the button below if you want to resend the link to your managing broker with
        referral a referral agreement.`;
        return (
            <div className="modal nu-modal fade message-modal" role="dialog">
                <div className="nu-modal-content">
                    <div className="modal-dialog">
                        <div className="modal-content modal-content-container">
                            <div className="modal-header">
                                <div className="modal-title"/>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {(showSignedRealtorNotSignedBrokerContent && showResendLink) ?
                                    <div className="signed-realtor-not-signed-broker text-center">
                                        <p><b>{messageWithResendLink}</b></p>
                                        <div className="button-block">
                                            <button onClick={this.handleResendReferralAgreement}
                                                    className="btn btn-default btn-resend-referral-agreement"
                                            >Resend Referral Agreement</button>
                                        </div>
                                    </div>
                                : showSignedRealtorNotSignedBrokerContent ?
                                    <div className="signed-realtor-not-signed-broker text-center">
                                        <p><b>{defaultMessageSignedRealtorNotSignedBroker}</b></p>
                                        <div className="button-block">
                                            <a className="btn btn-default btn-create-template"
                                               href={global.baseUrl + "getDefaultProposal"}
                                               onClick={() => {
                                                   trackEvent('Flow', 'Pop-Up', 'agentOpenTemplate', {
                                                       'IMD_Status': immediateProposal || 0,
                                                       'triggered_from':'Pop-up',
                                                       'platform':'Website'
                                                   }).withGA();
                                               }}
                                            >Create template</a>
                                            <a className="btn btn-default btn-complete-profile"
                                               href={global.baseUrl + "my-agent-profile"}
                                               onClick={() => {
                                                   mixpanel.track('editProfile',{'triggered_from':'Pop-up','platform':'Website'});
                                                   mixpanel.people.set({'lastEvent': 'editProfile','userType':userType})
                                               }}
                                            >Complete my profile</a>
                                        </div>
                                    </div>
                                :
                                    <div className="text-center">
                                        <div dangerouslySetInnerHTML={{ __html: '' + message}}></div>
                                        <button type='submit' className='submit-button btn btn-md btn-default ok-button' data-dismiss="modal">OK</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
